import user from './../../assets/image/socialIcon/icons8-user.png'
import phone from './../../assets/image/socialIcon/icons8-whatsapp.svg'
import email from './../../assets/image/socialIcon/icons8-message.png'
import telegram from './../../assets/image/socialIcon/icons8-telegram.svg'
import github from './../../assets/image/socialIcon/icons8-github.svg'
import chat from './../../assets/image/socialIcon/icons8-chat.png'
import message from './../../assets/image/socialIcon/icons8-messageFilled.png'

export const myContactsIcon={
    user,
    phone,
    email,
    telegram,
    github,
    chat,
    message,
}